module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/qr.js/lib/ErrorCorrectLevel.js
// module id = LpmL
// module chunks = 43